export const getHostUrl = () => {
  if(window.location.hostname.endsWith('staging.splunk.com')) {
    return 'https://www.staging.splunk.com';
  }

  return 'https://www.splunk.com'
}
